import ApplicationAdapter from 'eflex/adapters/application';

export default class GepicsBomSourceAdapter extends ApplicationAdapter {
  pathForType() {
    return 'bomSources';
  }
}
